export enum StatusEnum {
    DEFAULT = 'Default',
    LOADING = 'Loading',
    SUCCESS = 'Success',
    ERROR = 'Error',
}
